import { Form } from '@faxi/web-form';
import styled from 'styled-components';

const StyledValueOfYourCarForm = styled(Form)``;

export { StyledValueOfYourCarForm };
